import idx from 'idx'

import { Search } from '../../api'
// initial state
// shape: [{ id, quantity }]
const state = {
    professionals: {},
    fetchingGetProfessionals: null
}

// getters
const getters = {
    professionalsForSearch: (state) => {
        return Object.keys(state.professionals).map(id => state.professionals[id])
    },

    professionalIds: (state) => {
        return [ ...new Set(Object.keys(state.professionals).map(id => state.professionals[id].id)) ].sort((a, b) => a - b)
    },
}

// actions
const actions = {
    async getProfessionalMapMarkers ({ state, getters, commit, dispatch }, payload) {

        try {
            let professionalsAround = await Search.getProfessionalMapMarkers(payload)

            let [ data ] = [ idx(professionalsAround, _ => _.data.data) ]

            commit('setProfessionals', [ data, [] ])

        } catch (error) {

        }
    },

    clearProfessionals({commit}) {
        commit('clearProfessionals')
    }
}

// mutations
const mutations = {
    setProfessionals (state, [ data, meta ]) {
        state.professionals = data.reduce((acc, professional) => {
            return {
                ...acc,
                ...{[professional.id]: professional}
            }
        }, state.professionals)
    },

    clearProfessionals (state) {
        state.professionals = [];
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./application/assets/js/site/store/modules/search.js